import FileUploadIcon from "@mui/icons-material/FileUpload";
import { LoadingButton } from "@mui/lab";
import { Box, Button, Input, Select, Stack, TextField, Typography } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import { useApiUrl, useGetIdentity } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import RoomStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/roomStatus";
import SiteSourceType from "@warriortrading/warriortrading.hermes.common.feathers/enums/siteSourceType";
import { useCallback, useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";

export const RoomsEdit = () => {
  const {
    saveButtonProps,
    refineCore: { queryResult },
    register,
    formState: { errors },
    watch,
    setValue,
    setError,
  } = useForm();
  const data = queryResult?.data?.data;
  const [highlightQuestions, setHighlightQuestions] = useState(false);
  const [sourceType, setSourceType] = useState<any>("");
  const [statusType, setStatusType] = useState();
  const apiUrl = useApiUrl();
  const [vendor, setVendor] = useState<any>("");
  const [vendorArr, setVendorArr] = useState<any[]>([]);
  const vendorArrFun = useCallback(() => {
    return dataProvider(apiUrl)
      .getList({
        resource: "stream-vendors",
        filters: [{ field: "status", operator: "eq", value: 0 }],
      })
      .then((res) => {
        if (res?.data && res?.data.length !== 0) {
          setVendorArr(res?.data);
        }
        return res?.data;
      });
  }, [apiUrl]);
  useEffect(() => {
    vendorArrFun();
  }, [vendorArrFun]);

  const [scheduleParams, setScheduleParams] = useState("");
  const [pusherParams, setPusherParams] = useState("");
  const [playerParams, setPlayerParams] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  useEffect(() => {
    if (data) {
      setSourceType(data?.sourceType);
      setStatusType(data?.status);
      if (data?.vendorId && data?.vendorId !== "0") {
        setVendor(data?.vendorId);
      }
      setPusherParams(JSON.stringify(data?.pusherParams));
      setPlayerParams(JSON.stringify(data?.playerParams));
      setScheduleParams(JSON.stringify(data?.scheduleParams));
      setCreatedAt(new Date(data?.createdAt).toLocaleString());
      setUpdatedAt(new Date(data?.updatedAt).toLocaleString());
      setImgUrl(data?.avatarUrl);
      setAlarmFileModerators(data?.alarmFileModerators);
      setAlarmModerators(data?.alarmModerators);
      setAlarmFileAttendees(data?.alarmFileAttendees);
      setAlarmAttendees(data?.alarmAttendees);
      setAlarmFileAnnouncement(data?.alarmFileAnnouncement);
      setAlarmAnnouncement(data?.alarmAnnouncement);
      setOnlyModCanWrite(data?.onlyModCanWrite);
      setHighlightQuestions(data?.highlightQuestions);
    }
  }, [data]);

  // picture upload parts
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const imageInput = watch("avatarUrl");
  const onChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      setIsUploadLoading(true);
      const formData = new FormData();
      const target = event.target;
      const file: File = (target.files as FileList)[0];
      formData.append("uri", file);
      const res = await dataProvider(apiUrl).create({
        resource: "file",
        variables: formData,
      });
      setValue("avatarUrl", res.data.rawUploadInfo.uri, {
        shouldValidate: true,
      });
      setImgUrl(res.data.rawUploadInfo.uri);
      setIsUploadLoading(false);
    } catch (error) {
      setError("avatarUrl", { message: "Upload failed. Please try again." });
      setIsUploadLoading(false);
    }
  };

  // Moderators Audio upload parts
  const [isModUploadLoading, setIsModUploadLoading] = useState(false);
  const [alarmFileModerators, setAlarmFileModerators] = useState("");
  const [alarmModerators, setAlarmModerators] = useState(false);
  const onModChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      setIsModUploadLoading(true);
      const formData = new FormData();
      const target = event.target;
      const file: File = (target.files as FileList)[0];
      formData.append("uri", file);
      const res = await dataProvider(apiUrl).create({
        resource: "file",
        variables: formData,
      });

      setValue("alarmFileModerators", res.data.rawUploadInfo.uri, {
        shouldValidate: true,
      });
      setAlarmFileModerators(res.data.rawUploadInfo.uri);
      setIsModUploadLoading(false);
    } catch (error) {
      setError("alarmFileModerators", {
        message: "Upload failed. Please try again.",
      });
      setIsModUploadLoading(false);
    }
  };

  // Attendees Audio upload parts
  const [isAttUploadLoading, setIsAttUploadLoading] = useState(false);
  const [alarmFileAttendees, setAlarmFileAttendees] = useState("");
  const [alarmAttendees, setAlarmAttendees] = useState(false);
  const onAttChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      setIsAttUploadLoading(true);
      const formData = new FormData();
      // const session = window.sessionStorage.getItem("authorization");
      const target = event.target;
      const file: File = (target.files as FileList)[0];
      formData.append("uri", file);
      const res = await dataProvider(apiUrl).create({
        resource: "file",
        variables: formData,
      });
      setValue("alarmFileAttendees", res.data.rawUploadInfo.uri, {
        shouldValidate: true,
      });
      setAlarmFileAttendees(res.data.rawUploadInfo.uri);
      setIsAttUploadLoading(false);
    } catch (error) {
      setError("alarmFileAttendees", {
        message: "Upload failed. Please try again.",
      });
      setIsAttUploadLoading(false);
    }
  };

  // Announcement Audio upload parts
  const [isAnnUploadLoading, setIsAnnUploadLoading] = useState(false);
  const [alarmFileAnnouncement, setAlarmFileAnnouncement] = useState("");
  const [alarmAnnouncement, setAlarmAnnouncement] = useState(false);
  const onAnnChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      setIsAnnUploadLoading(true);
      const formData = new FormData();
      const target = event.target;
      const file: File = (target.files as FileList)[0];
      formData.append("uri", file);
      const res = await dataProvider(apiUrl).create({
        resource: "file",
        variables: formData,
      });
      setValue("alarmFileAnnouncement", res.data.rawUploadInfo.uri, {
        shouldValidate: true,
      });
      setAlarmFileAnnouncement(res.data.rawUploadInfo.uri);
      setIsAnnUploadLoading(false);
    } catch (error) {
      setError("alarmFileAnnouncement", {
        message: "Upload failed. Please try again.",
      });
      setIsAnnUploadLoading(false);
    }
  };

  // News Room Mode switch
  const [onlyModCanWrite, setOnlyModCanWrite] = useState(false);

  // updatedBy setting value
  type IUser = {
    user: {
      nickname: string;
    };
  };
  const dataUser = useGetIdentity<IUser>()?.data;
  const [updatedBy, setUpdatedBy] = useState("");
  useEffect(() => {
    if (dataUser) {
      setUpdatedBy(dataUser?.user?.nickname);
    }
  }, [dataUser]);
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box component="form" sx={{ "& button": { m: 1 } }} autoComplete="off">
        <TextField
          {...register("name", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register("title", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.title}
          helperText={(errors as any)?.title?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Title"
          name="title"
        />
        <TextField
          {...register("channel", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.channel}
          helperText={(errors as any)?.channel?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Channel"
          name="channel"
        />
        <TextField
          {...register("offlineMessage", {})}
          error={!!(errors as any)?.offlineMessage}
          helperText={(errors as any)?.offlineMessage?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="OfflineMessage"
          name="offlineMessage"
        />
        <TextField
          {...register("maxOnlineCount", {})}
          error={!!(errors as any)?.maxOnlineCount}
          helperText={(errors as any)?.maxOnlineCount?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="MaxOnlineCount"
          name="maxOnlineCount"
        />
        <TextField
          {...register("gatewayUrl", {})}
          error={!!(errors as any)?.gatewayUrl}
          helperText={(errors as any)?.gatewayUrl?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="GatewayUrl"
          name="gatewayUrl"
        />
        <FormControl
          fullWidth
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <InputLabel id="source-type-label">
            RoomSourceType :{" "}
            {
              Object.values(SiteSourceType)[0].find(
                (item: any) => item.value === sourceType
              )?.name
            }
          </InputLabel>
          <Select
            {...register("sourceType", {})}
            labelId="source-type-label"
            defaultValue={sourceType}
            value={sourceType || sourceType === 0 ? sourceType : ""}
            label="RoomSourceType"
            onChange={(event: SelectChangeEvent) => {
              setSourceType(event.target.value as any);
            }}
          >
            {Object.values(SiteSourceType)[0].map((item: any) => {
              return (
                <MenuItem key={item.value} value={item.value}>
                  {item.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl
          fullWidth
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <InputLabel id="status-label">
            Status :{" "}
            {
              Object.values(RoomStatus)[0].find(
                (item: any) => item.value === statusType
              )?.name
            }
          </InputLabel>
          <Select
            {...register("status", {})}
            labelId="status-label"
            value={
              statusType === null || statusType === undefined ? "" : statusType
            }
            label="Status"
            onChange={(event: SelectChangeEvent) => {
              setStatusType(event.target.value as any);
            }}
          >
            {Object.values(RoomStatus)[0].map((item: any) => {
              return (
                <MenuItem key={item.value} value={item.value}>
                  {item.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl
          fullWidth
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <InputLabel id="vendor-label">Vendor</InputLabel>
          <Select
            {...register("vendorId", {})}
            value={vendor || vendor === "0" ? vendor : ""}
            label="Vendor"
            onChange={(event: SelectChangeEvent) => {
              setVendor(event.target.value as any);
            }}
          >
            {vendorArr.length !== 0
              ? vendorArr.map((item: any) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
        <TextField
          error={!!(errors as any)?.pusherParams}
          helperText={(errors as any)?.pusherParams?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="PusherParams"
          name="pusherParams"
          multiline
          rows={4}
          value={pusherParams}
          disabled
        />
        <TextField
          error={!!(errors as any)?.playerParams}
          helperText={(errors as any)?.playerParams?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="PlayerParams"
          name="playerParams"
          multiline
          rows={4}
          value={playerParams}
          disabled
        />
        <TextField
          {...register("scheduleParams", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.scheduleParams}
          helperText={(errors as any)?.scheduleParams?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="ScheduleParams"
          name="scheduleParams"
          multiline
          rows={4}
          value={scheduleParams}
          disabled
        />
        <TextField
          {...register("channelId", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.channelId}
          helperText={(errors as any)?.channelId?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="ChannelId"
          name="newChannelId"
          defaultValue="Add old streamChannelId that you want get back(for screen)"
        />
        <TextField
          error={!!(errors as any)?.createdAt}
          helperText={(errors as any)?.createdAt?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="CreatedAt"
          name="createdAt"
          value={createdAt}
          disabled
        />
        <TextField
          error={!!(errors as any)?.updatedAt}
          helperText={(errors as any)?.updatedAt?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="UpdatedAt"
          name="updatedAt"
          value={updatedAt}
          disabled
        />
        <Input
          {...register("updatedBy", {})}
          sx={{ display: "none" }}
          value={updatedBy}
        />
        <Stack
          direction="row"
          gap={4}
          flexWrap="wrap"
          sx={{ marginTop: "16px" }}
        >
          {imageInput && (
            <Box
              component="img"
              sx={{
                width: 50,
                height: 50,
              }}
              src={imgUrl}
              alt="Room Avatar"
            />
          )}
          <label htmlFor="images-input">
            <Input
              {...register("avatarUrl", {})}
              id="images-input"
              type="file"
              sx={{ display: "none" }}
              onChange={onChangeHandler}
            />
            <LoadingButton
              loading={isUploadLoading}
              loadingPosition="end"
              endIcon={<FileUploadIcon />}
              variant="contained"
              component="span"
            >
              Upload Image
            </LoadingButton>
            <br />
            {errors.avatarUrl && (
              <Typography variant="caption" color="#fa541c">
                {errors.avatarUrl?.message?.toString()}
              </Typography>
            )}
          </label>
        </Stack>
        <h2>Moderators Audio :</h2>
        <div>
          Audio File:{" "}
          <a
            href={data?.alarmFileModerators}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data?.alarmFileModerators}
          </a>
          <audio
            id="alarmFileModerators"
            src={data?.alarmFileModerators}
            preload="preload"
          ></audio>
        </div>
        <Button
          variant="contained"
          size="medium"
          disabled={data?.alarmFileModerators === null}
          onClick={() => {
            let audio: HTMLMediaElement = document?.getElementById(
              "alarmFileModerators"
            ) as HTMLMediaElement;
            audio?.play();
          }}
        >
          PLAY
        </Button>
        <label htmlFor="images-input1">
          <Input
            {...register("alarmFileModerators", {
              // required: "This field is required",
            })}
            id="images-input1"
            type="file"
            sx={{ display: "none" }}
            onChange={onModChangeHandler}
          />
          <LoadingButton
            loading={isModUploadLoading}
            loadingPosition="end"
            endIcon={<FileUploadIcon />}
            variant="contained"
            component="span"
          >
            Upload Audio
          </LoadingButton>
          <br />
          {errors.alarmFileModerators && (
            <Typography variant="caption" color="#fa541c">
              {errors.alarmFileModerators?.message?.toString()}
            </Typography>
          )}
        </label>
        <Switch
          {...register("alarmModerators", {})}
          checked={alarmModerators}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setAlarmModerators(event.target.checked as any);
          }}
        />
        <h2>Attendees Audio :</h2>
        <div>
          Audio File:{" "}
          <a
            href={data?.alarmFileAttendees}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data?.alarmFileAttendees}
          </a>
          <audio
            id="alarmFileAttendees"
            src={data?.alarmFileAttendees}
            preload="preload"
          ></audio>
        </div>
        <Button
          variant="contained"
          size="medium"
          disabled={data?.alarmFileAttendees === null}
          onClick={() => {
            let audio: HTMLMediaElement = document?.getElementById(
              "alarmFileAttendees"
            ) as HTMLMediaElement;
            audio?.play();
          }}
        >
          PLAY
        </Button>
        <label htmlFor="images-input2">
          <Input
            {...register("alarmFileAttendees", {
              // required: "This field is required",
            })}
            id="images-input2"
            type="file"
            sx={{ display: "none" }}
            onChange={onAttChangeHandler}
          />
          <LoadingButton
            loading={isAttUploadLoading}
            loadingPosition="end"
            endIcon={<FileUploadIcon />}
            variant="contained"
            component="span"
          >
            Upload Audio
          </LoadingButton>
          <br />
          {errors.alarmFileAttendees && (
            <Typography variant="caption" color="#fa541c">
              {errors.alarmFileAttendees?.message?.toString()}
            </Typography>
          )}
        </label>
        <Switch
          {...register("alarmAttendees", {})}
          checked={alarmAttendees}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setAlarmAttendees(event.target.checked as any);
          }}
        />
        <h2>Announcement Audio :</h2>
        <div>
          Audio File:{" "}
          <a
            href={data?.alarmFileAnnouncement}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data?.alarmFileAnnouncement}
          </a>
          <audio
            id="alarmFileAnnouncement"
            src={data?.alarmFileAnnouncement}
            preload="preload"
          ></audio>
        </div>
        <Button
          variant="contained"
          size="medium"
          disabled={data?.alarmFileAnnouncement === null}
          onClick={() => {
            let audio: HTMLMediaElement = document?.getElementById(
              "alarmFileAnnouncement"
            ) as HTMLMediaElement;
            audio?.play();
          }}
        >
          PLAY
        </Button>
        <label htmlFor="images-input3">
          <Input
            {...register("alarmFileAnnouncement", {})}
            id="images-input3"
            type="file"
            sx={{ display: "none" }}
            onChange={onAnnChangeHandler}
          />
          <LoadingButton
            loading={isAnnUploadLoading}
            loadingPosition="end"
            endIcon={<FileUploadIcon />}
            variant="contained"
            component="span"
          >
            Upload Audio
          </LoadingButton>
          <br />
          {errors.alarmFileAnnouncement && (
            <Typography variant="caption" color="#fa541c">
              {errors.alarmFileAnnouncement?.message?.toString()}
            </Typography>
          )}
        </label>
        <Switch
          {...register("alarmAnnouncement", {})}
          checked={alarmAnnouncement}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setAlarmAnnouncement(event.target.checked as any);
          }}
        />
        <h2>News Room Mode :</h2>
        <Switch
          {...register("onlyModCanWrite", {})}
          checked={onlyModCanWrite}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setOnlyModCanWrite(event.target.checked as any);
          }}
        />
        <h2>HighlightQuestions :</h2>
        <Switch
          {...register("highlightQuestions", {})}
          checked={highlightQuestions}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setHighlightQuestions(event.target.checked as any);
          }}
        />
      </Box>
    </Edit>
  );
};
